// React reducers

import { combineReducers } from 'redux';
import { entitiesReducer, queriesReducer } from 'redux-query';
import { intlReducer } from 'react-intl-redux';
import { routerReducer } from 'react-router-redux';

import { brandingReducer } from './brandingReducer';
import { editAssociationReducer } from './editAssociationReducer';
import { addBidReducer } from './addBidReducer';
import { loadingBarReducer } from 'react-redux-loading-bar';
import { searchFiltersActiveJobsReducer } from './searchFiltersActiveJobsReducer';
import { searchFiltersAssociationExportOrdersReducer } from './searchFiltersAssociationExportOrdersReducer';
import { searchFiltersAssociationsReducer } from './searchFiltersAssociationsReducer';
import { searchFiltersClientContactsReducer } from './searchFiltersClientContactsReducer';
import { searchFiltersClientDashboardReducer } from './searchFiltersClientDashboardReducer';
import { searchFiltersClientsReducer } from './searchFiltersClientsReducer';
import { searchFiltersCoordinatorJobsReducer } from './searchFiltersCoordinatorJobsReducer';
import { searchFiltersNewResearchBidsReducer } from './searchFiltersNewResearchBidsReducer';
import { searchFiltersOrdersReducer } from './searchFiltersOrdersReducer';
import { searchFiltersOutstandingBidsReducer } from './searchFiltersOutstandingBidsReducer';
import { searchFiltersPreparedBidsReducer } from './searchFiltersPreparedBidsReducer';
import { searchFiltersSendBidsReducer } from './searchFiltersSendBidsReducer';
import { searchFiltersReminderBidsReducer } from './searchFiltersReminderBidsReducer';
import { searchFiltersResearchBidsReducer } from './searchFiltersResearchBidsReducer';
import { searchFiltersResearchComponentsReducer } from './searchFiltersResearchComponentsReducer';
import { searchFiltersUsersReducer } from './searchFiltersUsersReducer';
import { searchFiltersWonJobsReducer } from './searchFiltersWonJobsReducer';
import { viewFiltersAssociationInventoryReducer } from './viewFiltersAssociationInventoryReducer';

const Reducers = combineReducers({
  branding: brandingReducer,
  editAssociation: editAssociationReducer,
  entities: entitiesReducer,
  intl: intlReducer,
  loadingBar: loadingBarReducer,
  queries: queriesReducer,
  router: routerReducer,
  addBid: addBidReducer,
  searchFiltersActiveJobs: searchFiltersActiveJobsReducer,
  searchFiltersAssociationExportOrders: searchFiltersAssociationExportOrdersReducer,
  searchFiltersAssociations: searchFiltersAssociationsReducer,
  searchFiltersClientContacts: searchFiltersClientContactsReducer,
  searchFiltersClientDashboard: searchFiltersClientDashboardReducer,
  searchFiltersClients: searchFiltersClientsReducer,
  searchFiltersCoordinatorJobs: searchFiltersCoordinatorJobsReducer,
  searchFiltersNewResearchBids: searchFiltersNewResearchBidsReducer,
  searchFiltersOrders: searchFiltersOrdersReducer,
  searchFiltersOutstandingBids: searchFiltersOutstandingBidsReducer,
  searchFiltersPreparedBids: searchFiltersPreparedBidsReducer,
  searchFiltersSendBids: searchFiltersSendBidsReducer,
  searchFiltersReminderBids: searchFiltersReminderBidsReducer,
  searchFiltersResearchBids: searchFiltersResearchBidsReducer,
  searchFiltersResearchComponents: searchFiltersResearchComponentsReducer,
  searchFiltersUsers: searchFiltersUsersReducer,
  searchFiltersWonJobs: searchFiltersWonJobsReducer,
  viewFiltersAssociationInventory: viewFiltersAssociationInventoryReducer,
});

export default Reducers;



// WEBPACK FOOTER //
// ./src/reducers/index.tsx